import useUserRequest from '../components/Common/useUserRequest';
import { HttpMethod } from '../components/Common/useFetch';
import { RequestOptions } from '../components/Common/useRequest';
import { useSelectedBusiness } from '../components/UserAccess/useSelectedBusiness';
import { ProductMappingDto } from './useGetSharedProductConnections';

interface SaveMappingsRequest {
  connectionId: string;
  mappings: ProductMappingDto[];
}

const useUpdateProductMappings = (options?: RequestOptions) => {
  const business = useSelectedBusiness();

  return useUserRequest<SaveMappingsRequest[]>({
    path: `/api/businesses/${business.id}/dataSharing/connections/productMappings`,
    method: HttpMethod.POST
  }, options);
};

export default useUpdateProductMappings;